import { useMediaQuery } from 'react-responsive'
import PropTypes from 'prop-types'

const DesktopBreakpoint = { minWidth: 1024 }
const MobileBreakpoint = { maxWidth: 1023 }

const DesktopView = ({ children }) => {
  const isDesktop = useMediaQuery(DesktopBreakpoint)
  return isDesktop ? children : null
}

DesktopView.propTypes = {
  children: PropTypes.node.isRequired
}

DesktopView.displayName = 'DesktopView'

const MobileView = ({ children }) => {
  const isMobile = useMediaQuery(MobileBreakpoint)
  return isMobile ? children : null
}

MobileView.propTypes = {
  children: PropTypes.node.isRequired
}

MobileView.displayName = 'MobileView'

export { DesktopBreakpoint, MobileBreakpoint, DesktopView, MobileView }
